import React, { useEffect, useState } from "react";
import { X } from "lucide-react";
import { api, fileUrl } from "../lib/api";
import { PageHero, Empty } from "../components/ui-parts";

const CATS = ["All", "Sanskrit Programmes", "Spoken Sanskrit Classes", "Training", "Volunteer Activities", "District Activities", "Camps", "Workshops", "Cultural"];

export default function Gallery() {
  const [list, setList] = useState([]);
  const [cat, setCat] = useState("All");
  const [lightbox, setLightbox] = useState(null);

  useEffect(() => { api.get("/gallery", { params: { category: cat !== "All" ? cat : undefined } }).then(r => setList(r.data)); }, [cat]);

  return (
    <div data-testid="gallery-page">
      <PageHero badge="Media" title="Photo & Video Gallery" subtitle="Moments from Sanskrit camps, classes and cultural events across Odisha." />
      <section className="section">
        <div className="container-narrow">
          <div className="flex flex-wrap gap-2 mb-8">
            {CATS.map(c => (
              <button key={c} onClick={() => setCat(c)} data-testid={`cat-${c}`} className={`px-3 py-1.5 rounded-full text-xs font-semibold ${cat === c ? "bg-[var(--js-primary)] text-white" : "bg-white border border-[var(--js-border)] text-[var(--js-muted)]"}`}>{c}</button>
            ))}
          </div>
          {list.length === 0 ? <Empty title="Gallery empty" hint="Admin can add photos and videos from the dashboard." /> :
            <div className="grid gap-3 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
              {list.map(g => (
                <button key={g.id} onClick={() => setLightbox(g)} className="relative overflow-hidden rounded-lg js-card p-0" data-testid={`gal-${g.id}`}>
                  {g.media_type === "video" ? <video src={fileUrl(g.file_url)} className="w-full h-52 object-cover" /> : <img src={fileUrl(g.file_url)} alt={g.title || ""} className="w-full h-52 object-cover" />}
                  {g.title && <div className="p-2 text-xs text-left text-[var(--js-muted)]">{g.title}</div>}
                </button>
              ))}
            </div>
          }
        </div>
      </section>
      {lightbox && (
        <div className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4" onClick={() => setLightbox(null)}>
          <button className="absolute top-4 right-4 text-white" data-testid="lightbox-close"><X /></button>
          <div className="max-w-5xl w-full" onClick={e => e.stopPropagation()}>
            {lightbox.media_type === "video" ? <video src={fileUrl(lightbox.file_url)} controls className="w-full max-h-[80vh]" /> : <img src={fileUrl(lightbox.file_url)} alt="" className="w-full max-h-[80vh] object-contain" />}
            {lightbox.title && <div className="text-white mt-3 text-center">{lightbox.title}</div>}
          </div>
        </div>
      )}
    </div>
  );
}
